import { resourceFeed, resourceImgs } from "@/mocks/chiagua";

export default function MemberResources() {
  const featured = resourceFeed[0];
  const rest = resourceFeed.slice(1);

  return (
    <section id="member" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">Member Only</p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">会员专享 · 内部资源</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              行程、商务、综艺、幕后等隐藏内容在此聚合整理，开通会员即享完整权限，一手资源抢先看。
            </p>
          </div>
          <a
            href="#join"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
          >
            开通会员解锁全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <a href="#member" className="group block h-full overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              <div className="relative h-44 w-full overflow-hidden md:h-52">
                <img
                  src={resourceImgs.a}
                  alt="顶流艺人行程内部整理"
                  title="吃瓜福利 内部资源行程"
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-vip-crown-2-line"></i> 会员专享
                </span>
              </div>
              <div className="p-5">
                <span className="text-xs font-medium text-accent-700">{featured.cat}</span>
                <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {featured.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
                <p className="mt-4 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i> {featured.read} 位会员已查看
                </p>
              </div>
            </a>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-3">
            {rest.map((r, i) => (
              <a
                key={r.title}
                href="#member"
                className="group flex flex-1 items-start gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-primary-50/40"
              >
                <div className="hidden h-20 w-28 shrink-0 overflow-hidden rounded-lg sm:block md:h-24 md:w-36">
                  <img
                    src={Object.values(resourceImgs)[i + 1] || resourceImgs.a}
                    alt={r.title}
                    title={r.title}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-xs font-medium text-secondary-800">
                      {r.cat}
                    </span>
                    <i className="ri-lock-2-line text-sm text-primary-500"></i>
                  </div>
                  <h3 className="mt-1.5 text-sm font-semibold text-foreground-900 group-hover:text-primary-700 md:text-[15px]">
                    {r.title}
                  </h3>
                  <p className="mt-1 hidden text-sm text-foreground-500 md:line-clamp-1">{r.summary}</p>
                  <p className="mt-2 flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-eye-line"></i> {r.read} 人已读
                  </p>
                </div>
                <i className="ri-arrow-right-s-line mt-1 text-xl text-foreground-300 group-hover:text-primary-500"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}